export default class AplicacaoService {

    static setStateMenuOpen(state) {
        localStorage.setItem(btoa('stateMenuOpen'), state ? 1 : 0);
    }

    static getStateMenuOpen() {
        return localStorage.getItem(btoa('stateMenuOpen')) != null ? localStorage.getItem(btoa('stateMenuOpen')) === "1" : true;
    }
}